import { createFileRoute } from "@tanstack/react-router";
import ServiceLandingPage from "@/components/ServiceLandingPage";
import { SERVICE_META } from "@/data/servicePageMeta";

const PAGE = SERVICE_META["sprinter-van-rental-cost"]!;
const PAGE_URL = "https://sprinter-van-rentals.com/sprinter-van-rental-cost";

export const Route = createFileRoute("/sprinter-van-rental-cost")({
  head: () => ({
    meta: [
      { title: PAGE.title },
      { name: "description", content: PAGE.metaDescription },
      { property: "og:title", content: PAGE.title },
      { property: "og:description", content: PAGE.metaDescription },
      { property: "og:type", content: "article" },
      { property: "og:url", content: PAGE_URL },
      { property: "og:image", content: "https://sprinter-van-rentals.com/sprinter913-91.png" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://sprinter-van-rentals.com/sprinter913-91.png" },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "@id": `${PAGE_URL}#article`,
          headline: "Sprinter Van Rental Cost",
          description: PAGE.metaDescription,
          mainEntityOfPage: PAGE_URL,
          author: { "@type": "Organization", name: "Sprinter Van Rentals" },
          publisher: {
            "@type": "Organization",
            name: "Sprinter Van Rentals",
            url: "https://sprinter-van-rentals.com",
          },
          about: "Sprinter van rental cost",
        }),
      },
    ],
  }),
  component: () => <ServiceLandingPage slug="sprinter-van-rental-cost" />,
});
